import { PermissionsEnum } from "@/auth/interfaces";
import {
  EstadosAgendamientoEnumChoice,
  EstadosContratoChoiceEnum,
  ModulosEnumChoice,
  a11yProps,
  sizeTab,
  useCheckPermissions,
} from "@/shared";
import { SingleTableBoxScene } from "@/shared/components/ui";
import { useDiccionarioMotivo } from "@/store/erp/diccionario_motivo/diccionario_motivo.store";
import { Box, Tab, Tabs } from "@mui/material";
import { useEffect, useState } from "react";
import { CustomTabPanel } from "../..";
import AgendamientoAgendadoPage from "./shared/componente/agendamiento-agendando/AgendamientoAgendadoTable";

const AgendamientosFinalizadosPage = () => {
  useCheckPermissions(PermissionsEnum.api_view_agendamiento);

  //STATE
  const [valueTab, setValueTab] = useState(0);

  const setFaseVenta = useDiccionarioMotivo().setFaseVenta;

  useEffect(() => {
    setFaseVenta(ModulosEnumChoice.AGENDAMIENTO);
  }, []);

  return (
    <SingleTableBoxScene
      title={"Instalación Finalizadas"}
      py={2}
    >
      <Box
        sx={{
          bgcolor: "background.paper",
          maxWidth: sizeTab,
          paddingBottom: 2,
        }}
      >
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs preventa"
        >
          <Tab label={"Todos"} value={0} {...a11yProps(0)} />
        </Tabs>
      </Box>

      <CustomTabPanel value={valueTab} index={0}>
        <AgendamientoAgendadoPage
          estado_agendamiento={`${EstadosAgendamientoEnumChoice.FINALIZADO},${EstadosAgendamientoEnumChoice.RECORDINADO}`}
          estado_contrato={EstadosContratoChoiceEnum.ACTIVO}
        />
      </CustomTabPanel>
    </SingleTableBoxScene>
  );
};

export default AgendamientosFinalizadosPage;
